import * as Sentry from "@sentry/browser";
import { PerformanceSentry } from "../performance.sentry";
var MarkPerformanceSentry = /** @class */ (function () {
    function MarkPerformanceSentry(entry, startTime, parentSpan) {
        this.entry = entry;
        this.startTime = startTime;
        this.parentSpan = parentSpan;
    }
    MarkPerformanceSentry.prototype.generateSpan = function () {
        var span = Sentry.startInactiveSpan({
            op: this.entry.entryType,
            name: this.entry.name,
            startTime: PerformanceSentry.parseMillisecondsToSeconds(this.startTime + this.entry.startTime),
            parentSpan: this.parentSpan,
        });
        span.end(PerformanceSentry.parseMillisecondsToSeconds(this.startTime + this.entry.startTime + Math.abs(this.entry.duration)));
    };
    return MarkPerformanceSentry;
}());
export { MarkPerformanceSentry };
//# sourceMappingURL=mark.performance.sentry.js.map